/*
 *   Copyright (c) 2024
 *   All rights reserved.
 */
// components/ClientErrorHandler.js
"use client";

import { useEffect } from "react";
import toast from "react-hot-toast";

const ClientErrorHandler = ({ error }) => {
  useEffect(() => {
    if (error) {
      if (error) toast.error(error);
    }
  }, [error]);

  return null;
};

export default ClientErrorHandler;
